import { create } from "zustand";
import { persist } from "zustand/middleware";
import { logAddToCart } from "../hook/useAnalytics";

export const useCartStore = create(
  persist(
    (set, get) => ({
      cartItems: [],
      addToCart: (product, quantity = 1) =>
        set((state) => {
          const existingItem = state.cartItems.find(
            (item) =>
              item.id === product.id &&
              item.selectedColor === product.selectedColor,
          );

          logAddToCart(product.id);

          if (existingItem) {
            return {
              cartItems: state.cartItems.map((item) =>
                item.id === product.id &&
                item.selectedColor === product.selectedColor
                  ? { ...item, quantity: item.quantity + quantity }
                  : item,
              ),
            };
          }
          return { cartItems: [...state.cartItems, { ...product, quantity }] };
        }),
      updateCartItemQuantity: (productId, delta, color) =>
        set((state) => {
          const target = state.cartItems.find(
            (item) => item.id === productId && item.selectedColor === color,
          );
          if (!target) {
            return state;
          }

          const nextQuantity = (target.quantity ?? 0) + delta;
          if (nextQuantity <= 0) {
            return {
              cartItems: state.cartItems.filter(
                (item) => !(item.id === productId && item.selectedColor === color),
              ),
            };
          }

          return {
            cartItems: state.cartItems.map((item) =>
              item.id === productId && item.selectedColor === color
                ? { ...item, quantity: nextQuantity }
                : item,
            ),
          };
        }),
      removeFromCart: (productId, color) =>
        set((state) => ({
          cartItems: state.cartItems.filter(
            (item) => !(item.id === productId && item.selectedColor === color),
          ),
        })),
      clearCart: () => set({ cartItems: [] }),
    }),
    {
      name: "foon-cart-storage",
    },
  ),
);
